import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import RoutesContext from './RoutesContext'


function Footer() {
    const routes_context = useContext(RoutesContext);

  return (
        <footer>
            <div className="footer_section_1">
                <div className="footer_section_1_col_1 footer_last_child">
                    <div className="button_animation footer_item"><Link to={routes_context.home_page} className="footer_item">Baş sahypa</Link></div>
                    <div className="button_animation footer_item"><Link to={routes_context.about_us} className="footer_item">Biz hakda</Link></div>
                    <div className="button_animation footer_item"><Link to={routes_context.news} className="footer_item">Täzelikler</Link></div>
                    <div className="button_animation footer_item"><Link to={routes_context.contacts} className="footer_item">Salgymyz</Link></div>
                </div>
    
                <div className="footer_section_1_col_2">
                    <a className="footer_flex_item footer_item" href="tel:80052256575">
                        <img src={require("./static/img/icons/phone.png")} alt="" />
                        80052256575
                    </a>
    
                    <a href="mailto:maryavtoulag@sanly.tm" className="footer_flex_item footer_item">
                        <img src={require("./static/img/icons/email.png")} alt="" />
                        maryavtoulag@sanly.tm
                    </a>
    
                    <a href="#" className="footer_flex_item footer_item">
                        <img src={require("./static/img/icons/small_location.png")} alt="" />
                        <span>745400 Mary ş. Ýeňişiň 50 ýyllygy köçesi, 54-nji jaýy</span>
                    </a>
    
                    <a href="#" className="footer_flex_item footer_item">
                        <img src={require("./static/img/icons/fax.png")} alt="" />
                        80052256214
                    </a>
                </div>
    
                <div className="footer_section_1_col_3">
                    <img src={require("./static/img/logo3.png")} alt="" />
                    <h6 className="footer_title_text">
                        "MARYAWTOULAG" <br />
                        ÖNÜMÇILIK BIRLEŞIGI
                    </h6>
                </div>
            </div>
            
            <div className="copyright_section">
                <p>Copyright 2021. Ähli hukuklary goragly</p>
            </div>
        </footer>
  )
}

export default Footer